// @ts-nocheck
/* eslint-disable */
export const arrowCircleDownIcon = {
    data: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16"><path fill="#798693" d="M8 1.333C4.327 1.333 1.333 4.327 1.333 8S4.327 14.667 8 14.667 14.667 11.673 14.667 8 11.673 1.333 8 1.333m2.707 6.18L8.353 9.867c-.1.1-.226.146-.353.146a.5.5 0 0 1-.353-.146L5.293 7.513a.503.503 0 0 1 0-.706.503.503 0 0 1 .707 0l2 2 2-2a.503.503 0 0 1 .707 0 .503.503 0 0 1 0 .706"/></svg>`,
    name: 'arrow-circle-down' as const
};